import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchContentLibraryThunk } from 'slices/campaigns/content/thunk';
import { AppDispatch, RootState } from 'store';
import { defaultContentLibraryFilters } from 'types/campaign/content';
import { formatNumber, generateUniqueKey } from 'utils/helpers';
import IGLogoPNG from "../../assets/images/brands/ig-logo.png"
import Skeleton from 'react-loading-skeleton';
const filters = defaultContentLibraryFilters;

const ContentLibPreview = () => {

    const [initialLoading, setInitialLoading] = useState(false);
    const [filterId, setFilterId] = useState(generateUniqueKey(filters, ['page']))
    const dispatch: AppDispatch = useDispatch();
    const contentLibraryData = useSelector((state: RootState) => state.contentLibrary.filtered_lists?.[filterId!]);
    const contentLibrary = contentLibraryData?.list ?? [];

    useEffect(() => {
        if (filters.page && filters.page === 1) {
            setInitialLoading(true);
        }

        dispatch(fetchContentLibraryThunk({ filters })).finally(() => {
            setFilterId(generateUniqueKey(filters, ['page']));
            setInitialLoading(false);
        })

    }, [filters])
    return (
        <div className='table-responsive dashboard-table'>
            <table className="">
                <thead>
                    <tr>
                        <th>Post</th>
                        <th className='text-start ps-4'>Likes</th>
                        <th className='text-start ps-4'>Comments</th>
                        <th className='text-start ps-4'>Views</th>
                        <th className='text-start ps-4'>Engagement Score</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        !initialLoading && contentLibrary.slice(0, 5).map((libraryItem, i) => {
                            return (
                                <tr className={`${i < 4 ? 'border-bottom-1 px-3' : ''} `} key={i}>
                                    <td>
                                        <div className="py-3">
                                            <div className="d-flex justify-content-start align-items-center gap-3 td-content">
                                                <a href={libraryItem.social_post.permalink} target='_blank' rel='noreferrer'><div className='bgc-content bg-image cursor-pointer' style={{ backgroundImage: `url(${libraryItem.social_post.thumbnail_url})`, height: '60px', width: '40px', borderRadius: '4px' }}></div></a>
                                                <div className="d-flex flex-column justify-content-center">
                                                    <div className="d-flex align-items-center gap-1">
                                                        {
                                                            libraryItem.social_post.platform === 'ig' &&
                                                            <img src={IGLogoPNG} alt="IG Logo" className='linked-posts-ig-logo' />
                                                        }
                                                        {
                                                            libraryItem.social_post.platform === 'yt' &&
                                                            <i className='ri-youtube-fill text-danger linked-posts-yt-logo mt-1'></i>
                                                        }

                                                        <span className='linked-posts-ig-username'>{libraryItem.social_post.social_account.handle}</span>
                                                    </div>
                                                    <span className='linked-post-posted-on'>{libraryItem.social_post.posted_on}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className='ps-4'>
                                        <div className="py-3">
                                            <div className="d-flex justify-content-start align-items-center gap-1 td-content">
                                                <span className=""> <i className='ri-heart-line me-1'></i> {formatNumber(Number(libraryItem.social_post?.like_count ?? 0))}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td className='ps-4'>
                                        <div className="py-3">
                                            <div className="d-flex justify-content-start align-items-center gap-1 td-content">
                                                <span className=""> <i className='ri-chat-3-line me-1'></i> {formatNumber(Number(libraryItem.social_post?.comments_count ?? 0))}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td className='ps-4'>
                                        <div className="py-3">
                                            <div className="d-flex justify-content-start align-items-center gap-1 td-content">
                                                <span className="">  <i className='ri-eye-line me-1'></i>  {formatNumber(Number(libraryItem.social_post?.views_count ?? 0))}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td className='ps-4'>
                                        <div className="py-3">
                                            <div className="d-flex justify-content-start align-items-center gap-1 td-content">
                                                <span>{libraryItem.social_post.engagement_score}</span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            )
                        })
                    }
                    {
                        (initialLoading) &&
                        Array.from({ length: 10 }).map((_, i) => {
                            return (
                                <tr key={i}>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                </tr>
                            )
                        })
                    }
                    {
                        (!initialLoading && contentLibrary.length === 0) &&
                        <tr>
                            <td colSpan={5} className="text-center py-4">
                                <span className='my-5'>Currently there is no collab in your library!</span>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}

export default ContentLibPreview